import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import "./App.sass";
import About from "./components/About";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { Swap } from './components/Swap';
import { WalletModel } from './components/WalletModel';
import { useCustomWeb3React } from './hooks/useCustomWeb3React';
import { useEagerConnect } from './hooks/walletConnect';
import { allowance, approve, balanceOf } from './contracts/functions/erc20';
import { ZERO_ADDRESS } from './utils/constants';
import {
	calculateEarnings,
	checkUnstakeStatus,
	stake,
	stakes,
	unstake,
	withdrawEarnings,
} from './contracts/functions/stakingContract';
import { selectDurationMsg } from './hooks/swal2';
import { useToaster } from './hooks/toaster';
import { Box, useTheme, Grid } from '@mui/material';
import { ToastContainer } from "react-bootstrap";
function App() {


	const { account, chainId } = useCustomWeb3React();
	const { } = useToaster();
	const _ = useEagerConnect();

	const [contractAddress, setContractAddress] = useState('');
	const [random, setRandom] = useState(Math.random());

	const [inAmount, setInAmount] = useState('');
	const [outAmount, setOutAmount] = useState('');

	const [isApproved, setIsApproved] = useState(false);

	const [refAddr, setRefAddr] = useState('');
	const [gRefAddr, setGRefAddr] = useState(account ?? '');

	const [balance, setBalance] = useState('0');
	const [userStakes, setUserStakes] = useState('0');
	const [earnings, setEarnings] = useState('0');
	const [userUnstakeStatus, setUserUnstakeStatus] = useState('0');

	const [page, setPage] = useState(0);
	const [open, setOpen] = useState(false);
	const theme = useTheme();

	const handlerRedeem = () => setPage(1);
	const handlerRefferral = () => setPage(2);
	const handlerBack = () => setPage(0);
	const handlerOpenWallets = () => setOpen(true);

	const handlerInAmount = (e) => setInAmount(e.target.value);
	const handlerOutAmount = (e) => setOutAmount(e.target.value);

	const handlerRefAddr = (e) => setRefAddr(e.target.value);
	const handlerGRefAddr = (e) => setGRefAddr(e.target.value);

	const handlerContractAddr = (addr) => setContractAddress(addr);

	const handlerRandom = () => setRandom(Math.random());

	const handlerStake = async () => {
		stake(contractAddress, account, refAddr ? refAddr : ZERO_ADDRESS, inAmount, () => {
			handlerRandom();
		});
	};

	const handlerApprove = async () => {
		if (contractAddress !== '') {
			approve(contractAddress, account, () => {
				handlerRandom();
			});
		} else {
			selectDurationMsg();
		}
	};

	const handlerUnstake = async () => {
		unstake(contractAddress, account, outAmount, () => {
			handlerRandom();
		});
	};

	const handlerIsApproved = async () => {
		if (account && contractAddress !== '') {
			setIsApproved(await allowance(account, contractAddress));
		}
	};

	const handlerWithdrawEarnings = async () => {
		withdrawEarnings(contractAddress, account, () => {
			handlerRandom();
		});
	};

	const init = async () => {
		if (account) {
			let _balance = await balanceOf(account);
			setBalance(_balance);
			if (contractAddress) {
				let _stakes = await stakes(contractAddress, account);
				let _unstakeStatus = await checkUnstakeStatus(contractAddress, account);
				let _earnings = await calculateEarnings(contractAddress, account);

				// console.log(_balance, _stakes, _unstakeStatus, _earnings);
				setUserStakes(_stakes);
				setUserUnstakeStatus(_unstakeStatus);
				setEarnings(_earnings);
			}
		}
	};

	useEffect(() => {
		init();
		handlerIsApproved();
	}, [account, chainId, contractAddress, random]);

	useEffect(() => {
		if (account) {
			setGRefAddr(account);
		}
	}, [account]);

	useEffect(() => {
		let path = window.location.pathname;
		let _ref = path.toLowerCase().slice(1);
		let isRef = /^0x[0-9a-f]{40}$/.test(_ref);
		if (isRef) {
			setRefAddr(_ref);
		} else {
			window.history.replaceState(undefined, undefined, '/');
		}
	}, []);



	return (
		<>
			<WalletModel open={open} setOpen={setOpen} />
			<ToastContainer style={{ fontSize: '0.9rem' }} />
			<Header
				connectMetaMask={handlerOpenWallets}
				account={account}
			/>
			<About
				account={account}
				withdraw={handlerWithdrawEarnings}
			/>
			<Footer />
		</>
	);
}

export default App;
